import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const ForgotPassword = React.lazy(() => import("../components/Login/ForgotPassword"));
  const Otp = React.lazy(() => import("../components/Login/Otp"));
  const CratePassword = React.lazy(() => import("../components/Login/CratePassword"));

  const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));

  const ManageRoles = React.lazy(() => import("../components/ManageRoles/ManageRoles"));
  const AddRole = React.lazy(() => import("../components/ManageRoles/AddEditRole"));

  const CMSListing = React.lazy(() => import("../components/ManageCMS/cms"));
  const AddCMS = React.lazy(() => import("../components/ManageCMS/AddEditCMS"));

  const UserListing = React.lazy(() => import("../components/ManageAdminUser/users"));
  const AddUser = React.lazy(() => import("../components/ManageAdminUser/AddEditUser"));

  const AppUserListing = React.lazy(() => import("../components/ManageAppUser/AppUserLisiting"));
  const ViewAppUser = React.lazy(() => import("../components/ManageAppUser/UserView"));

  const NotificationListing = React.lazy(() => import("../components/ManageNotification/Notification"));
  const AddNotification = React.lazy(() => import("../components/ManageNotification/AddEditNotification"));
  const ViewNotification = React.lazy(() => import("../components/ManageNotification/ViewNotification"));

  const ProfileSetting = React.lazy(() => import("../components/Header/profileSetting"));

  const FAQListing = React.lazy(() => import("../components/ManageFAQ/FAQListing"));
  const FAQAddEdit = React.lazy(() => import("../components/ManageFAQ/AddEditFAQ"));

  const TeamMemberListing = React.lazy(() => import("../components/ManageTeamMember/TeamMemberLisiting"));
  const TeamMemberAddEdit = React.lazy(() => import("../components/ManageTeamMember/AddEditTeamMember"));

  const ServiceTypeListing = React.lazy(() => import("../components/ManageServiceType/ServiceTypeListing"));
  const ServiceTypeAddEdit = React.lazy(() => import("../components/ManageServiceType/AddEditServiceType"));

  const ServiceRequest = React.lazy(() => import("../components/ManageServiceRequest/ServiceBookingListing"));
  const ViewServiceRequest = React.lazy(() => import("../components/ManageServiceRequest/ViewServiceBooking"));

  const SubscriptionFeature = React.lazy(() => import("../components/SubscriptionFeature/FeatureListing"));

  const SubscriptionListing = React.lazy(() => import("../components/ManageSubscriptions/SubscriptionListing"));
  const AddEditSubscription = React.lazy(() => import("../components/ManageSubscriptions/AddEditSubscription"));

  const PincodeListing = React.lazy(() => import("../components/ManagePincode/PincodeListing"));
  const AddEditPincode = React.lazy(() => import("../components/ManagePincode/AddEditPincode"));

  const Setting = React.lazy(() => import("../components/ManageSetting/HandleSetting"));

  const BannerList = React.lazy(() => import("../components/ManageBanner/BannerListing"));
  const AddEditBanner = React.lazy(() => import("../components/ManageBanner/AddEditBanner"));

  const ServiceProviderList = React.lazy(() => import("../components/ManageServiceProvider/ServiceProviderListing"));
  const AddEditProvider = React.lazy(() => import("../components/ManageServiceProvider/AddEditServiceProvider"));

  const ManageSupport = React.lazy(() => import("../components/ManageSupport/ManageSupport"));

  const TransactionListing = React.lazy(() => import("../components/ManageTransaction/TransactionList"));
  const AuditLogsListing = React.lazy(() => import("../components/ManageAuditLogs/AuditLogsList"));

  const CouponListing = React.lazy(() => import("../components/ManageCoupon/CouponListing"));
  const AddEditcoupon = React.lazy(() => import("../components/ManageCoupon/AddEditCoupon"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route path="/login" element={<Suspense fallback={<></>}> <Login /> </Suspense>} />
          <Route path="/forgot-password" element={<Suspense fallback={<></>}> <ForgotPassword /> </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<></>}> <Otp /> </Suspense>} />
          <Route path="/crate-password" element={<Suspense fallback={<></>}> <CratePassword /> </Suspense>} />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
            <Route path="/dashboard" element={<Suspense fallback={<></>}> <Dashboard /> </Suspense>} />

            <Route path="/manage-roles" element={<Suspense fallback={<></>}> <ManageRoles /> </Suspense>} />
            <Route path="/add-role" element={<Suspense fallback={<></>}> <AddRole /> </Suspense>} />
            <Route path="/edit-role/:id" element={<Suspense fallback={<></>}> <AddRole /> </Suspense>} />

            <Route path="/manage-cms" element={<Suspense fallback={<></>}> <CMSListing /> </Suspense>} />
            <Route path="/add-cms" element={<Suspense fallback={<></>}> <AddCMS /> </Suspense>} />
            <Route path="/edit-cms/:id" element={<Suspense fallback={<></>}> <AddCMS /> </Suspense>} />

            <Route path="/manage-admin-user" element={<Suspense fallback={<></>}> <UserListing /> </Suspense>} />
            <Route path="/add-user" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />
            <Route path="/edit-user/:id" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />

            <Route path="/manage-app-user" element={<Suspense fallback={<></>}> <AppUserListing /> </Suspense>} />
            <Route path="/view-user/:id" element={<Suspense fallback={<></>}> <ViewAppUser /> </Suspense>} />

            <Route path="/manage-notifications" element={<Suspense fallback={<></>}> <NotificationListing /> </Suspense>} />
            <Route path="/add-notification" element={<Suspense fallback={<></>}> <AddNotification /> </Suspense>} />
            <Route path="/edit-notification/:id" element={<Suspense fallback={<></>}> <AddNotification /> </Suspense>} />
            <Route path="/view-notification/:id" element={<Suspense fallback={<></>}> <ViewNotification /> </Suspense>} />

            <Route path="/profile-setting" element={<Suspense fallback={<></>}><ProfileSetting /></Suspense>} />

            <Route path="/faqs" element={<Suspense fallback={<></>}><FAQListing /></Suspense>} />
            <Route path="/add-faq" element={<Suspense fallback={<></>}><FAQAddEdit /></Suspense>} />
            <Route path="/edit-faq/:id" element={<Suspense fallback={<></>}><FAQAddEdit /></Suspense>} />

            <Route path="/manage-team-members" element={<Suspense fallback={<></>}><TeamMemberListing /></Suspense>} />
            <Route path="/add-member" element={<Suspense fallback={<></>}><TeamMemberAddEdit /></Suspense>} />
            <Route path="/edit-member/:id" element={<Suspense fallback={<></>}><TeamMemberAddEdit /></Suspense>} />

            <Route path="/manage-service-types" element={<Suspense fallback={<></>}><ServiceTypeListing /></Suspense>} />
            <Route path="/add-service-type" element={<Suspense fallback={<></>}><ServiceTypeAddEdit /></Suspense>} />
            <Route path="/edit-service-type/:id" element={<Suspense fallback={<></>}><ServiceTypeAddEdit /></Suspense>} />

            <Route path="/manage-service-requests" element={<Suspense fallback={<></>}><ServiceRequest /></Suspense>} />
            <Route path="/view-service-request/:uuid" element={<Suspense fallback={<></>}><ViewServiceRequest /></Suspense>} />

            <Route path="/manage-subscription-feature" element={<Suspense fallback={<></>}><SubscriptionFeature /></Suspense>} />

            <Route path="/manage-subscriptions" element={<Suspense fallback={<></>}><SubscriptionListing /></Suspense>} />
            <Route path="/add-subscription" element={<Suspense fallback={<></>}><AddEditSubscription /></Suspense>} />
            <Route path="/edit-subscription/:id" element={<Suspense fallback={<></>}><AddEditSubscription /></Suspense>} />

            <Route path="/manage-pincodes" element={<Suspense fallback={<></>}><PincodeListing /></Suspense>} />
            <Route path="/add-pincode" element={<Suspense fallback={<></>}><AddEditPincode /></Suspense>} />
            <Route path="/edit-pincode/:id" element={<Suspense fallback={<></>}><AddEditPincode /></Suspense>} />

            <Route path="settings" element={<Suspense fallback={<></>}><Setting /></Suspense>} />

            <Route path="/banners" element={<Suspense fallback={<></>}><BannerList /></Suspense>} />
            <Route path="/add-banner" element={<Suspense fallback={<></>}><AddEditBanner /></Suspense>} />
            <Route path="/edit-banner/:id" element={<Suspense fallback={<></>}><AddEditBanner /></Suspense>} />

            <Route path="/manage-service-providers" element={<Suspense fallback={<></>}><ServiceProviderList /></Suspense>} />
            <Route path="/add-service-providers" element={<Suspense fallback={<></>}><AddEditProvider /></Suspense>} />
            <Route path="/edit-service-providers/:id" element={<Suspense fallback={<></>}><AddEditProvider /></Suspense>} />

            <Route path="/manage-support" element={<Suspense fallback={<></>}><ManageSupport /></Suspense>} />

            <Route path="/transactions" element={<Suspense fallback={<></>}><TransactionListing /></Suspense>} />

            <Route path="/audit-logs" element={<Suspense fallback={<></>}><AuditLogsListing /></Suspense>} />

            <Route path="/coupen-codes" element={<Suspense fallback={<></>}><CouponListing /></Suspense>} />
            <Route path="/add-coupon" element={<Suspense fallback={<></>}><AddEditcoupon /></Suspense>} />
            <Route path="/edit-coupon/:id" element={<Suspense fallback={<></>}><AddEditcoupon /></Suspense>} />

          </Route>
        </Routes >
      </div >
    </>
  );
};

export default Navigation;
